import { UserRoleKey } from '../types';

export const AVAILABLE_ROLES: UserRoleKey[] = [
  "WORKER",
  "ADMIN",
  "OFFICE",
  "GROWER",
  "DEV",
  "SELLER",
  "CUSTOMER",
  "DRIVER"
];

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
  WORKER: "עובד",
  ADMIN: "מנהל",
  OFFICE: "משרד",
  GROWER: "מגדל",
  DEV: "מפתח",
  SELLER: "מוכר",
  CUSTOMER: "לקוח",
  DRIVER: "נהג",
};
